import React, { useEffect } from "react";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import {shallowEqual, useSelector, useDispatch} from "react-redux";
import {actions} from "app/modules/Auth/_redux/authRedux";

const AgentBalance = () => {
  const user = useSelector(state => state.auth?.user, shallowEqual);

  const dispatch  = useDispatch();

  useEffect(() => {
   const interval = setInterval(() => dispatch(actions.getProfile()), 10000);

   return () => clearInterval(interval)

  }, []);

  return (
    <div className="d-flex align-items-center px-2 my-2">
      <span className="svg-icon svg-icon-2x svg-icon-primary d-flex justify-content-center mr-2">
        <AccountBalanceWalletIcon />
      </span>
      <span className="text-primary font-weight-bold font-size-h6 d-flex align-items-center">
        Balans: {user.deposit ? (+user.deposit).toFixed(2) : "-"}
      </span>
    </div>
  );
};

export default AgentBalance;
